import { AnnotationsChartConfigRequiredProps } from './types/annotations-chart-config-props.js';
import {
  DEFAULT_LABELS_WIDTH,
  DEFAULT_SHOW_LABELS,
  DEFAULT_TEXT_OVERFLOW,
  DEFAULT_TRUNCATION_MODE,
} from '../core/components/annotations/constants.js';

export const DEFAULT_AXIS_HIDDEN = false;

export const DEFAULT_NUMERICAL_AXIS_TYPE = 'linear';

export const DEFAULT_TOOLTIP_HIDDEN = false;

export const DEFAULT_ANNOTATIONS_CHART_CONFIG: AnnotationsChartConfigRequiredProps =
  {
    showLabels: DEFAULT_SHOW_LABELS,
    height: undefined,
    labelWidth: DEFAULT_LABELS_WIDTH,
    xAxisConfig: {
      hidden: DEFAULT_AXIS_HIDDEN,
    },
    tooltipConfig: {
      hidden: DEFAULT_TOOLTIP_HIDDEN,
      template: undefined,
    },
    textOverflow: DEFAULT_TEXT_OVERFLOW,
    truncateMode: DEFAULT_TRUNCATION_MODE,
  };

export const ANNOTATIONS_CHART_ARIA_LABEL = 'Annotations Chart';
